<p-dropdown
  class="option-dropdown"
  [ngClass]="styleClass"
  [ngStyle]="{ 'min-width': minWidth }"
  [dropdownIcon]="dropdownIcon"
  [options]="options"
  [ngModel]="value"
  [ngModelOptions]="{ standalone: true }"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [appendTo]="appendTo"
  [panelStyleClass]="panelStyleClass"
  (onChange)="handleChange($event)"
  (onShow)="handleShow()"
  (onHide)="handleHide()"
>
  <ng-template let-option pTemplate="selectedItem">
    <div class="option-dropdown__selected">
      <span class="option-dropdown__label">{{ option?.label }}</span>
      <hospitality-bot-status-chip
        *ngIf="showStatusChip && option?.status"
        [status]="option.status"
        [config]="statusChipConfig"
      ></hospitality-bot-status-chip>
    </div>
  </ng-template>

  <ng-template let-option pTemplate="item">
    <div class="option-dropdown__option">
      <div class="option-dropdown__selected">
        <span class="option-dropdown__label">{{ option?.label }}</span>
        <hospitality-bot-status-chip
          *ngIf="showStatusChip && option?.status"
          [status]="option.status"
          [config]="statusChipConfig"
        ></hospitality-bot-status-chip>
      </div>
      <span
        class="option-dropdown__amount"
        *ngIf="showAmount && option?.amount != null"
      >
        {{ option.amount | dynamicCurrency }}
      </span>
    </div>
  </ng-template>
</p-dropdown>
